module.exports = __webpack_public_path__ + "img/9788983945204.fb55e19c.jpg";